import PromptContent from "slotworks/components/prompt/prompt-content";
import RetriggerFreespins from "slotworks/state-machine/standard/states/retrigger-freespins";

export default class AGSRetriggerFreespins extends RetriggerFreespins {
    protected showPrompt(prompt?: PromptContent) {
        if (!prompt) {
            prompt = new PromptContent(["freespinsretrigger"], 3200);
        }

        super.showPrompt(prompt);
    }
}
